"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inject = void 0;

var _styledComponents = require("styled-components");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        width: 100%;\n        height: auto;\n        left: 0;\n        right: 0;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        width: auto;\n        height: 100%;\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _reversePosition = function _reversePosition(position) {
  return {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right'
  }[position];
};

var dimensions = function dimensions(position) {
  switch (position) {
    case 'left':
    case 'right':
      return (0, _styledComponents.css)(_templateObject());

    case 'top':
    case 'bottom':
    default:
      return (0, _styledComponents.css)(_templateObject2());
  }
};

var border = function border(position) {
  return "border-".concat(_reversePosition(position), ": 1px solid var(--c-light);");
};

var position = function position(_ref) {
  var position = _ref.position,
      isOpen = _ref.isOpen;
  return "".concat(position, ": ").concat(isOpen ? 0 : '-100%');
};

var transition = function transition(_ref2) {
  var position = _ref2.position,
      isOpen = _ref2.isOpen;
  return "transition: ".concat(position, " var(--transition) ").concat(isOpen ? 'cubic-bezier(0, 1, 0, 1)' : 'cubic-bezier(1, 0, 1, 0)', ";");
};

var inject = {
  dimensions: dimensions,
  border: border,
  position: position,
  transition: transition
};
exports.inject = inject;